import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    imports: [CommonModule],
    selector: 'app-legend-label',
    templateUrl: './legend-label.component.html',
    styleUrls: ['./legend-label.component.scss']
})
export class LegendLabelComponent implements OnInit {
  @Input('colorTypes') colorTypes:any;
  @Input('config') config:any;
  @Output() legendToggle = new EventEmitter();

  deactivatedLabels = new Set<string>();

  constructor() { }

  ngOnInit(): void {
  }

  get isInteractive(): boolean {
    return this.config?.interactive_legends === true;
  }

  isDeactivated(item: any): boolean {
    return this.deactivatedLabels.has(this.getLabel(item));
  }

  toggleItem(item: any): void {
    // debugger
    if (!this.isInteractive) return;
    const label:any = this.getLabel(item);
    if (this.deactivatedLabels.has(label)) {
      this.deactivatedLabels.delete(label);
    } else {
      this.deactivatedLabels.add(label);
    }
    this.legendToggle.emit(label);
  }

  /**
   * Get items where flag is false or undefined (shown before separator)
   */
  get itemsBeforeSeparator(): any[] {
    return this.colorTypes?.filter((item: any) => !item.flag) || [];
  }

  /**
   * Get items where flag is true (shown after separator)
   */
  get itemsAfterSeparator(): any[] {
    return this.colorTypes?.filter((item: any) => item.flag) || [];
  }

  /**
   * Get the label from the color type object
   * @param item - Color type item
   * @returns Label string
   */
  getLabel(item: any): string {
    // Get the first (and only) key from the object
    const key = Object.keys(item).find(k => k !== 'flag');
    return key || '';
  }

  /**
   * Get the color value from the color type object
   * @param item - Color type item
   * @returns Color hex value
   */
  getColorValue(item: any): string {
    const key = Object.keys(item).find(k => k !== 'flag');
    return key ? item[key] : '#ffffff';
  }

}
